import { InputGroup } from "@/components/ui/input";

export function MachineTimeInput({ currentExport, data, setData }) {
  if (
    currentExport == "Machine CM SOT" ||
    currentExport == "Machine PM SOT" ||
    currentExport == "Machine OTH SOT"
  ) {
    return (
      <InputGroup
        label="Time"
        type="month"
        value={data.month_year ? data.month_year : ""}
        onChange={(e) => {
          setData({ ...data, month_year: e.target.value });
        }}
      />
    );
  }
  return null;
}
